import React from "react";
import "./Solution.css";
import SolutionboxT2 from "../../components/Solutionbox/S-T2/SolutionboxT2";
import SolutionboxT1 from "../../components/Solutionbox/S-T1/SolutionboxT1";


const Solution = () => {
  return (
    <div className="solution-page">
      <h2 className="title">Our Solutions</h2>
      <div className="solution-content">
        <>
          <div id="Retrofit-Process-&-Mechanical-Systems">
            <SolutionboxT1
              image="/Images/solution-icons/solution-images/retrofit.png"
              solution="Retrofit Process & Mechanical Systems"
              description={
                <>
                  <i>Breathe new life into aging infrastructure.</i> <br />  <br />
                  <p>At Boltcrew Engineering, we specialize in upgrading existing mechanical systems to meet modern standards of efficiency and safety. We don’t just replace parts; we optimize your entire process.</p> <br />
                  <ul>
                    <li style={{marginBottom: "10px"}}>System Analysis: Comprehensive auditing of your current mechanical setups to identify bottlenecks and energy waste.</li>
                    <li style={{marginBottom: "10px"}}>Modernization: Integrating advanced technologies into legacy systems to improve performance and extend equipment lifespan.</li>
                    <li style={{marginBottom: "10px"}}>Custom Fabrication: Designing and installing bespoke mechanical components tailored to your facility’s unique footprint.</li>
                    <li style={{marginBottom: "10px"}}>Turnkey Execution: From initial teardown to final commissioning, we manage the entire retrofit lifecycle with minimal downtime.</li>
                  </ul>
                </>
              }
            />
          </div>
          <div id="Preventive-Maintenance-&-Service-Contracts">
            <SolutionboxT2
              image="/Images/solution-icons/solution-images/preventive.png"
              solution="Preventive Maintenance & Service Contracts"
              description={
                <>
                  <i>Proactive care to eliminate unplanned downtime.</i> <br />  <br />
                  <p>The most expensive repair is the one you didn't see coming. Our maintenance programs are designed to keep your operations running at peak performance while reducing long-term operational costs.</p> <br />
                  <ul>
                    <li style={{marginBottom: "10px"}}>Scheduled Inspections: Routine health checks for mechanical and electrical assets to catch minor issues before they escalate.</li>
                    <li style={{marginBottom: "10px"}}>Condition Monitoring: Utilizing diagnostic tools to track vibrations, heat signatures, and wear patterns.</li>
                    <li style={{marginBottom: "10px"}}>Lubrication & Calibration: Ensuring all moving parts and instruments are operating within precise manufacturer specifications.</li>
                    <li style={{marginBottom: "10px"}}>Detailed Reporting: We provide comprehensive documentation and "Health Certificates" for your machinery to assist with compliance and asset management.</li>
                  </ul>
                </>
              }
            />
          </div>
          <div id="Spare-Part-Management-&-Supply">
            <SolutionboxT1
              image="/Images/solution-icons/solution-images/spare.png"
              solution="Spare Part Management & Supply"
              description={
                <>
                  <i>The right part, at the right time.</i> <br />  <br />
                  <p>Supply chain disruptions shouldn't stop your production line. Boltcrew Engineering provides a strategic approach to inventory, ensuring you have access to high-quality components whenever you need them.</p> <br />
                  <ul>
                    <li style={{marginBottom: "10px"}}>Critical Spares Auditing: We help you identify "mission-critical" parts that should always be in stock.</li>
                    <li style={{marginBottom: "10px"}}>Sourcing & Procurement: A global network of trusted OEMs and suppliers to provide genuine parts at competitive prices.</li>
                    <li style={{marginBottom: "10px"}}>Inventory Optimization: Helping you balance stock levels to reduce tied-up capital while maintaining 100% availability.</li>
                    <li style={{marginBottom: "10px"}}>Rapid Delivery: Efficient logistics to ensure that urgent replacement parts reach your site without delay.</li>
                  </ul>
                </>
              }
            />
          </div>
          <div id="Electrical-&-Control-System">
            <SolutionboxT2
              image="/Images/solution-icons/solution-images/electrical.png"
              solution="Electrical & Control System"
              description={
                <>
                  <i>Precision control for complex operations.</i> <br />  <br />
                  <p>Our electrical division ensures that your power distribution and automation systems are safe, compliant, and intelligent. We bridge the gap between heavy machinery and smart control.</p> <br />
                  <ul>
                    <li style={{marginBottom: "10px"}}>Power Distribution: Design and installation of LV/MV panels, switchgear, and cabling infrastructure.</li>
                    <li style={{marginBottom: "10px"}}>Automation & PLC Programming: Custom control logic to automate manual processes and improve accuracy.</li>
                    <li style={{marginBottom: "10px"}}>System Integration: Seamlessly connecting your mechanical assets with modern SCADA or HMI interfaces for real-time monitoring.</li>
                    <li style={{marginBottom: "10px"}}>Testing & Safety: Rigorous electrical testing, earthing solutions, and fault-finding to ensure a safe working environment.</li>
                  </ul>
                </>
              }
            />
          </div>
        </>
      </div>
    </div>
  );
};

export default Solution;

